import { Component, Inject, HostListener, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
@Component({
  selector: 'eng-compare-view',
  templateUrl: './comparision-view.component.html',
  styleUrls: ['./comparision-view.component.scss']
})
export class ComparisionViewComponent implements OnInit, OnDestroy, AfterViewInit {

  loginUser: any;
  assessorList: any;
  sectionList: any;
  allowAccess: boolean;
  menuItemAllowAccess: boolean;
  mandatoryQuestionList: any[] = [];
  currentFocusedField = -1;
  firstMandatoryFieldIndex = -1;
  lastMandatoryFieldIndex = -1;
  unansweredRequiredFields: any[] = [];
  allowedCloneRoles: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      assessors: any,
      comparisionAssessmentData: any,
      loginUser: any,
      allowAccess: any,
      menuItemAllowAccess: any,
      mandatoryQuestionList: any,
      allowedCloneRoles: any

    },
    private mdDialogRef: MatDialogRef<ComparisionViewComponent>,
    private confirmationDialogService: ConfirmationDialogService
  ) {
    this.mdDialogRef.disableClose = true;
    this.assessorList = this.data.assessors;
    this.sectionList = this.data.comparisionAssessmentData;
    this.loginUser = this.data.loginUser;
    this.allowAccess = this.data.allowAccess;
    this.menuItemAllowAccess = this.data.menuItemAllowAccess;
    this.mandatoryQuestionList = this.data.mandatoryQuestionList;
    this.allowedCloneRoles = this.data.allowedCloneRoles
  }

  public cancel() {
    this.close(false);
  }
  close(value?: boolean) {
    this.confirmExit();
  }

  confirmExit() {
    if (this.allowAccess && this.menuItemAllowAccess) {
      this.confirmationDialogService.open({
        btnCancelText: "No",
        btnConfirmText: "Yes",
        message: "Please save your remarks before exiting. Unsaved changes will be lost. Do you want to continue?"
      });

      this.confirmationDialogService.confirmed().subscribe(result => {
        if (result) {
          this.mdDialogRef.close({ saved: false });
        }
      });
    } else {
      this.mdDialogRef.close({ saved: false });
    }
  }
  public confirm() {
    this.close(true);
  }
  @HostListener("keydown.esc")
  public onEsc() {
    this.close(false);
  }
  ngOnInit() {
  }


  ngOnDestroy(): void {

  }

  ngAfterViewInit() {
    this.initializeValues();
  }

  initializeValues() {
    let fieldIndex = 0;
    const unAnsweredRequiredFields: any[] = [];

    this.sectionList.forEach(section => {
      section.questions.forEach(question => {
        question.answers.forEach(answer => {

          if (answer.assessedBy === this.loginUser.login) {
            answer.fieldIndex = fieldIndex++;
            if (this.isFieldInvalid(question, answer)) {
              answer.parentSection = section;
              unAnsweredRequiredFields.push(answer);
            }
          }
        });
      });
    });
    this.unansweredRequiredFields = unAnsweredRequiredFields;

    if (this.unansweredRequiredFields.length > 0) {
      this.firstMandatoryFieldIndex = this.unansweredRequiredFields[0].fieldIndex;
      this.lastMandatoryFieldIndex = this.unansweredRequiredFields[this.unansweredRequiredFields.length - 1].fieldIndex;
    }
  }

  navigateToMandatoryField(direction: 'next' | 'previous') {
    let nextOrPrevInvalidAnswer;

    if (direction === 'next') {
      nextOrPrevInvalidAnswer = this.unansweredRequiredFields.find(answer =>
        answer.fieldIndex > this.currentFocusedField);
    } else {
      nextOrPrevInvalidAnswer = this.unansweredRequiredFields.slice().reverse().find(answer =>
        answer.fieldIndex < this.currentFocusedField);
    }
    if (nextOrPrevInvalidAnswer) {
      // Automatically force-expand the parent accordion if it is hidden/collapsed
      if (!nextOrPrevInvalidAnswer.parentSection.open) {
        nextOrPrevInvalidAnswer.parentSection.open = true;
      }
      // A minor delay gives Angular time to repaint 
      // the elements to the DOM if a section was previously closed.
      setTimeout(() => {
        const targetElement = document.getElementById(`dialog-textarea-${nextOrPrevInvalidAnswer.fieldIndex}`);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          (targetElement as HTMLElement).focus();
          this.currentFocusedField = nextOrPrevInvalidAnswer.fieldIndex;
        }
      });
    }
  }

  save() {
    this.mdDialogRef.close({ saved: true });
  }

  isFieldInvalid(question, answerItem): boolean {
    // we are showing the error only for the user who is logged in not for the disabled fields
    if (!answerItem || answerItem.assessedBy !== this.loginUser.login) {
      return false;
    }

    if (!this.isQuestionRequired(question)) return false;
    const value = answerItem.assessmentData && answerItem.assessmentData[answerItem.fieldCode];

    return (value === null || value === undefined || value.toString().trim() === '');
  }

  isQuestionRequired(question): boolean {
    if (!question || !question.required) { return false; }

    if (question.requiredForRole && question.requiredForRole.trim()) {

      const allowedRoles = question.requiredForRole.split(',').map(role => role.trim().toUpperCase()).filter(role => role);

      return allowedRoles.includes(this.loginUser.role.toUpperCase());
    }
    // if no role restriction then mandatory for all
    return true;
  }

  copyAssessment(assessor): void {
    this.confirmationDialogService.open({ "btnCancelText": "No", "btnConfirmText": "Yes", "message": "Copy review remarks from " + assessor.label + "? This action will replace any existing review remarks entered by you." })
    this.confirmationDialogService.confirmed().subscribe(confirm => {
      if (confirm) {
        this.mandatoryQuestionList.forEach(item => {
          const sourceAnswer = item.question.answers.find(
            answer => answer.assessedBy === assessor.assessedBy);

          if (sourceAnswer) {
            item.answer.assessmentData[item.answer.fieldCode] =
              sourceAnswer.assessmentData[sourceAnswer.fieldCode];
          }
        });
        this.initializeValues();
      }
    });
  }
}
